
import {Frequency, FrequencyType} from './frequency';
import {Rating} from './rating';

export class ReviewsOverview {

  id: string;

  mainRating: Rating;
  otherRatings: Rating[] = [];
  frequencyList: Frequency[] = [];
  frequencyCount = 0;
  surveyCount = 0;
  maxStars = 0;

  constructor(public data: any) {
    const json: JSON = data;

    this.id = json['id'];

    if (json['overall']) {

      this.surveyCount = json['overall']['survey_count'];
      this.maxStars    = json['overall']['maxStars'];

      if (json['overall']['main']) {
        this.mainRating = new Rating(json['overall']['main']);
      }

      if (json['overall']['other']) {
        for (const rating of json['overall']['other']) {
          this.otherRatings.push(new Rating(rating));
        }
      }
    }

    if (json['frequency']) {
      let total = 0;
      for (const freq of json['frequency']) {
        const frequency = new Frequency(freq, FrequencyType.Builder);
        total = total + frequency.count;
        this.frequencyList.push(frequency);
      }

      this.frequencyCount = total;

      // calculate the frequency percentages
      for (const freq of this.frequencyList) {
        freq.percentageString = Math.round((freq.count / total) * 100) + '%';
      }
    }
  }
}

/*

"results": {
  "frequency": [
    {
      "frequency": 23,
      "qlabel": "Overall Rating",
      "score": 6
    },
    {
      "frequency": 11,
      "qlabel": "Overall Rating",
      "score": 5
    },
    {
      "frequency": 1,
      "qlabel": "Overall Rating",
      "score": 4
    },
    {
      "frequency": 0,
      "qlabel": "Overall Rating",
      "score": 3
    },
    {
      "frequency": 0,
      "qlabel": "Overall Rating",
      "score": 2
    },
    {
      "frequency": 0,
      "qlabel": "Overall Rating",
      "score": 1
    }
  ],
    "id": "acme-homes",
    "is_active": 1,
    "is_public_report": 1,
    "last_run": {
    "dt": "2015-06-16 18:42:15.375013",
      "param_dates": {
      "receipt_end_dt": "12/31/2014",
        "receipt_start_dt": "10/01/2013"
    },
    "user_name": "API Reviews Admin"
  },
  "overall": {
    "main": {
      "qindex": 0,
        "qlabel": "Overall Rating",
        "qscore": 5.4,
        "stars": 5.5
    },
    "other": [
      {
        "qindex": 1,
        "qlabel": "Home Quality",
        "qscore": 5.4,
        "stars": 5.5
      },
      {
        "qindex": 2,
        "qlabel": "Overall Service",
        "qscore": 5.5,
        "stars": 5.5
      },
      {
        "qindex": 3,
        "qlabel": "Time Taken to Correct Items",
        "qscore": 5.3,
        "stars": 5.5
      },
      {
        "qindex": 4,
        "qlabel": "Would Recommend Builder",
        "qscore": 5.9,
        "stars": 6.0
      }
    ],
      "survey_count": 35,
      "maxStars": 6
  }
}
*/



// WEBPACK FOOTER //
// ./src/app/model/reviews-overview.ts